"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _Discussion = require("../Discussion");

var _SurveyModal = require("components/SurveyModal");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp2;

var FeedbackBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(FeedbackBody, _Component);

  function FeedbackBody() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, FeedbackBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(FeedbackBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(FeedbackBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "comment"
      }, _react.default.createElement("button", {
        className: "btn btn-default",
        onClick: this.showSurveyResult
      }, 'View Abuse Report'));
    }
  }, {
    key: "showSurveyResult",
    value: function showSurveyResult() {
      new _SurveyModal.SurveyResultModal(this.node.survey, this.node.account, new Date(this.node.created)).show();
    }
  }]);
  return FeedbackBody;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showSurveyResult", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showSurveyResult"), _class.prototype)), _class);
var CommentNode = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(CommentNode, _Component2);

  function CommentNode() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, CommentNode);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(CommentNode)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "node", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "commentPosted", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "trackData", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "discussion", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      expanded: false,
      userProfile: null,
      submitting: false
    };
    return _this2;
  }

  babelHelpers.createClass(CommentNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      $(document).on('profileUpdated', this.profileUpdatedEvent);
      (0, _userProfile.getUserProfile)().then(this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(document).off('profileUpdated', this.profileUpdatedEvent);
    }
  }, {
    key: "profileUpdatedEvent",
    value: function profileUpdatedEvent(event) {
      this.profileUpdated(event.profile);
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(profile) {
      this.setState({
        userProfile: profile
      });
    }
  }, {
    key: "doPostComment",
    value: function doPostComment(comment) {
      return (0, _fetch.default)('data/discussion/post', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          child_type: 'reply',
          parent: this.node.node.id,
          comment: comment,
          trackData: this.trackData
        })
      }).then(function (result) {
        if (result.status == 204) return true;
        if (!result.ok) throw result.json();
        return result.json();
      });
    }
  }, {
    key: "submitComment",
    value: function submitComment(comment) {
      var _this3 = this;

      return new _promisePolyfill.default(function (resolve, reject) {
        _this3.setState({
          submitting: true
        }, function () {
          _this3.doPostComment(comment).then(function (result) {
            _this3.setState({
              submitting: false
            }, function () {
              (0, _noty.showNotificationText)('Your comment has been posted.');

              _this3.commentPosted();

              resolve(true);
            });
          }).catch(function (error) {
            _this3.setState({
              submitting: false
            }, function () {
              reject(error);
            });
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      if (this.node) {
        return _react.default.createElement("div", {
          className: "comment-thread"
        }, _react.default.createElement(_node.default, {
          node: this.node.node,
          isAbuseReport: true,
          menu: this.node.node.permissions.delete ? [{
            title: 'Delete',
            invoke: this.doDelete
          }] : [],
          discussion: this.discussion,
          oldFooter: _react.default.createElement("footer", null, _react.default.createElement("div", {
            className: "submit"
          }, this.node.node.permissions.reply ? _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doReply,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "reply"
          }), "\xA0 Reply") : null, this.node.node.permissions.delete ? _react.default.createElement("a", {
            className: "btn btn-link",
            onClick: this.doDelete,
            href: "javascript:void(0)"
          }, _react.default.createElement("span", {
            className: "material-icons",
            "data-icon": "delete"
          }), "\xA0 Delete") : null))
        }, _react.default.createElement(FeedbackBody, {
          node: this.node.node
        })), _react.default.createElement("section", {
          className: _classList.default.join('child-comments', this.state.expanded && 'open')
        }, _react.default.createElement("div", {
          className: "sub-comment-list"
        }, this.node.children.length ? this.node.children.map(function (child) {
          return _react.default.createElement(_Discussion.DiscussionNode, {
            discussion: _this4.discussion,
            trackData: _this4.trackData,
            key: child.node.id,
            commentPosted: _this4.commentPosted,
            node: child
          });
        }) : null)));
      }

      return null;
    }
  }, {
    key: "doDelete",
    value: function doDelete(event) {
      var _this5 = this;

      (0, _fetch.default)('data/discussion/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.node.node.id,
          trackData: this.trackData
        })
      }).then(function () {
        (0, _noty.showNotificationText)('The abuse report has been deleted.');

        _this5.commentPosted();
      });
      if (event) event.preventDefault();
      return false;
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(field) {
      this.commentField = field;
    }
  }, {
    key: "toggleExpando",
    value: function toggleExpando() {
      this.setState(function (st) {
        return {
          expanded: !st.expanded
        };
      });
    }
  }, {
    key: "doReply",
    value: function doReply() {
      var _this6 = this;

      this.setState({
        expanded: true
      }, function () {
        _this6.commentField.focus();
      });
    }
  }]);
  return CommentNode;
}(_react.Component), _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profileUpdatedEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "profileUpdatedEvent"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "profileUpdated"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "submitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "submitComment"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "doDelete", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "doDelete"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "gotCommentField"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "toggleExpando", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "toggleExpando"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "doReply", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "doReply"), _class3.prototype)), _class3);
exports.default = CommentNode;